function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M501.333,85.333h-256c-10.267,0-19.319,4.945-25.178,12.486C198.521,76.229,169.766,64,138.667,64 c-18.156,0-36.219,7.438-48.302,19.906l-22.094,22.76H45.177c-17.302,0-31.375,14.354-31.375,32c0,5.094,1.177,9.917,3.26,14.188 C6.938,158.177,0,168.938,0,181.333c0,12.396,6.938,23.156,17.063,28.479c-2.083,4.271-3.26,9.094-3.26,14.188 c0,14.667,9.719,27.052,22.938,30.823c-1.438,3.667-2.229,7.667-2.229,11.844c0,17.646,14.073,32,31.365,32H160 c20.319,0,40.034-6.625,56.405-18.539c5.103,10.913,16.107,18.539,28.928,18.539H320v138.667c0,5.896,4.771,10.667,10.667,10.667 c23.854,0,36.385-6.26,47.438-11.792c10.24-5.125,19.083-9.542,37.896-9.542s27.656,4.417,37.896,9.542 C464.948,441.74,477.479,448,501.333,448c5.896,0,10.667-4.771,10.667-10.667V96C512,90.104,507.229,85.333,501.333,85.333z  M320,277.333h-74.667c-5.885,0-10.667-4.781-10.667-10.667V117.333c0-5.885,4.781-10.667,10.667-10.667H320V277.333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.333,256c11.76,0,21.333-9.573,21.333-21.333c0-11.76-9.573-21.333-21.333-21.333 c-11.76,0-21.333,9.573-21.333,21.333C256,246.427,265.573,256,277.333,256z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgWaiter = function SvgWaiter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaiter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waiter.ea81bf0c.svg";
export { ForwardRef as ReactComponent };